const B_1 = [
    {
        title: '文件协作',
        path: '/bidding/projectflow/fabiao/wjxz/index'
    }
]

export default {
    path: 'wjxz',
    component: () => import(/*webpackChunkName: 'bidding-kai-getoffer'*/ '@layout/empty'),
    children: [
        {
            path:"index",
            component: () => import('@views/bidding/views/project-flow/fa/wen-jian-xie-zuo/index'),
            meta: {
                title: '文件协作',
                bread: B_1
            },
        },
    ]
}